"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TiposOp;
(function (TiposOp) {
    TiposOp["SUMA"] = "SUMA";
    TiposOp["RESTA"] = "RESTA";
    TiposOp["MULTIPLICACION"] = "MULTIPLICACION";
    TiposOp["DIVISION"] = "DIVISION";
    TiposOp["MODULO"] = "MODULO";
    TiposOp["AND"] = "AND";
    TiposOp["OR"] = "OR";
    TiposOp["ASIGNACION"] = "ASIGNACION";
    TiposOp["NO_IGUAL"] = "NO_IGUAL";
    TiposOp["MAYOR_QUE"] = "MAYOR_QUE";
    TiposOp["MENOR_QUE"] = "MENOR_QUE";
    TiposOp["MAYOR_IGUAL"] = "MAYOR_IGUAL";
    TiposOp["MENOR_IGUAL"] = "MENOR_IGUAL";
})(TiposOp = exports.TiposOp || (exports.TiposOp = {}));
